export const formatDateToLocale = (date: string) => {
  if (!date) return '-';

  return Intl.DateTimeFormat(navigator.language, {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date(date));
};
